// extracted by mini-css-extract-plugin
export default {"button":"_7a2f1b8e","heartLink":"_47ba6932","heartIcon":"_f66b4df9"};